export default class FormSelect {
    constructor() {
        this.$select = $('.js-search-select');
        this.$input = this.$select.children('.js-search-input');
        this.$button = this.$select.children('.js-search-select-button');
        this.$select = this.$button.parent('.js-search-select');
        this.$list = this.$select.children('.js-search-select-list').children('.js-search-select-list-inner');
        this.$listItem = this.$list.children('li');
    }

    bindProcess(){

        this.checkFreezeSelect();

        this.checkSelected();

        this.startHide();

        this.$button.on('click', (e)=>{
            this.$currentButton = $(e.currentTarget);
            this.$currentSelect = this.$currentButton.parent('.js-search-select');
            this.$currentInput = this.$currentSelect.children('.js-search-input');
            this.$currentList = this.$currentSelect.children('.js-search-select-list').children('.js-search-select-list-inner');

            if (this.$currentSelect.hasClass('is-open')) {
                this.hide();
            } else {
                this.open();
            }
        });

        this.$listItem.on('click', (e)=>{
            this.$currentItem = $(e.currentTarget);
            this.hide();
            
            this.dataHref = this.$currentItem.attr('data-href')

            
            let val = this.$currentItem.attr('data-select');
            let text = this.$currentItem.text();
            this.$currentInput.attr('value', val);
            this.$currentButton.text(text);

            location.href = this.dataHref;
            this.checkFreezeSelect();




        });
    }

    startHide() {
        this.$list.slideUp(0)
    }

    hide() {
        this.$currentSelect.removeClass('is-open');
        this.$currentList.slideUp();
    }

    open() {
        this.reset();
        if (!this.$currentSelect.hasClass('is-freeze')) {
            this.$currentSelect.addClass('is-open');
            this.$currentList.slideDown();
        }
    }

    reset() {
        this.$list.slideUp();
        this.$select.removeClass('is-open');
    }

    checkSelected(){
        this.$input.each((num, target)=>{
            let $target = $(target);
            let $targetListItem = $target.parent().children('.js-search-select-list').children('.js-search-select-list-inner').children('li');
            if ($target.attr('value') !== '') {
                let value = $target.attr('value');
                let text = '';
                $targetListItem.each((itemNum, itemTarget)=>{
                    let $itemTarget = $(itemTarget);
                    if ($itemTarget.attr('data-select') === value) {
                        text = $itemTarget.text();
                        $target.parent().children('.js-search-select-button').text(text);
                    }
                });
            }
        });
    }
    
    checkFreezeSelect() {
        let requiredVal = $('#js-search-required').children('.js-search-input').attr('value');
        if (requiredVal === '') {
            $('#js-search-passive').addClass('is-freeze');
        } else {
            $('#js-search-passive').removeClass('is-freeze');
        }

    }

}